import React, { PropsWithChildren } from "react";
import cn from "classnames";

/**
 * The title component of a section, which can be used in the header.
 */
/**
 * @deprecated
 */
export const SectionTitle: React.FC<PropsWithChildren<{}>> = ({ children }: PropsWithChildren<{}>) => {
  const className = cn("section-title");
  return <h1 className={className}>{children}</h1>;
};
